import { useContext, useState, useEffect } from 'react'

import { SlotContext } from '../../context'

export const Slot = ({ name }) => {
  const hostController = useContext(SlotContext)
  const [component, setComponent] = useState(null)

  useEffect(() => hostController.waitFor(name, setComponent), [])

  return component
}
